import { Pipe, PipeTransform } from '@angular/core';
import {CustomLayoutField} from '../Models/custom-layout-field.model';
import {CustomLayoutsService} from '../custom-layouts.service';
import { LoginService } from '../../../shared-modules/login/login.service';


@Pipe({
  name: 'getFieldDisplayName'
})
export class GetFieldDisplayNamePipe implements PipeTransform {
  constructor(private customLayoutService: CustomLayoutsService,
    private loginService: LoginService) {
  }

  transform(field: CustomLayoutField, args: any): any {
    let fieldName = '';
    if (field.DQFieldID > 0) {
    if (this.loginService.LoginSettings.V10) {
      const dqField = this.customLayoutService.dataQueryFields.find(f => f.ID == field.DQFieldID );
      if (dqField) {
        fieldName = dqField.DisplayName;
      }
    }
    else {
      const dqField = this.customLayoutService.dataQueryFields.find(f => f.ID == field.DQFieldID &&   f.CategoryID == field.CategoryId);
      if (dqField) {
        fieldName = dqField.DisplayName;
      }
    }
    }
    else if (field.SpecialFieldID > 0) {
      const sField = this.customLayoutService.specialFields.find(f => f.Id == field.SpecialFieldID);
      if (sField) {
        fieldName = sField.DisplayName;
      }
    }
    return fieldName;
  }

}
